import React from 'react';
export default class PlayerUIVisibilityManager extends React.Component {
  UNSAFE_componentWillReceiveProps(_ref) {
    let {
      isPlayerUIVisible,
      showPlayerUI,
      hidePlayerUI
    } = _ref;
    if (isPlayerUIVisible !== this.props.isPlayerUIVisible) {
      isPlayerUIVisible // eslint-disable-line no-unused-expressions
      ? showPlayerUI && showPlayerUI() : hidePlayerUI && hidePlayerUI();
    }
  }
  render() {
    return null;
  }
}
//# sourceMappingURL=ui-visibility-manager.js.map